var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTestTubeFilled = function SvgTestTubeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.72 3.22a.75.75 0 0 1 1.06 0l7 7a.75.75 0 1 1-1.06 1.06l-.47-.47-9.97 9.97a4.286 4.286 0 0 1-6.06-6.06l9.97-9.97-.47-.47a.75.75 0 0 1 0-1.06m1.53 2.59L8.061 12h7.879l2.25-2.25z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.004 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0M20.004 2.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  })));
};
export default SvgTestTubeFilled;